import {
    ANNULER_ENTRETIEN_ANNUEL_FAIL,
    ANNULER_ENTRETIEN_ANNUEL_REQUEST,
    ANNULER_ENTRETIEN_ANNUEL_SUCCESS,
    APPROVE_OBJECTIF_FAIL,
    APPROVE_OBJECTIF_MODIFICATION_FAIL,
    APPROVE_OBJECTIF_MODIFICATION_REQUEST,
    APPROVE_OBJECTIF_MODIFICATION_SUCCESS,
    APPROVE_OBJECTIF_REQUEST,
    APPROVE_OBJECTIF_SUCCESS,
    CANCEL_OBJECTIF_MODIFICATION_FAIL,
    CANCEL_OBJECTIF_MODIFICATION_REQUEST,
    CANCEL_OBJECTIF_MODIFICATION_SUCCESS,
    COMPLETE_PLAN_DEVELOPPEMENT_STEP_FAIL,
    COMPLETE_PLAN_DEVELOPPEMENT_STEP_REQUEST,
    COMPLETE_PLAN_DEVELOPPEMENT_STEP_SUCCESS,
    CONFIRMER_ENTRETIEN_ANNUEL_FAIL,
    CONFIRMER_ENTRETIEN_ANNUEL_REQUEST,
    CONFIRMER_ENTRETIEN_ANNUEL_SUCCESS,
    CREATE_DEMANDE_FORMATION_FROM_PLAN_FAIL,
    CREATE_DEMANDE_FORMATION_FROM_PLAN_REQUEST,
    CREATE_DEMANDE_FORMATION_FROM_PLAN_SUCCESS,
    CREATE_OBJECTIF_AUTO_EVALUATION_FAIL,
    CREATE_OBJECTIF_AUTO_EVALUATION_REQUEST,
    CREATE_OBJECTIF_AUTO_EVALUATION_SUCCESS,
    CREATE_OBJECTIF_FAIL,
    CREATE_OBJECTIF_MANAGER_EVALUATION_FAIL,
    CREATE_OBJECTIF_MANAGER_EVALUATION_REQUEST,
    CREATE_OBJECTIF_MANAGER_EVALUATION_SUCCESS,
    CREATE_OBJECTIF_N_MOINS_1_FAIL,
    CREATE_OBJECTIF_N_MOINS_1_REQUEST,
    CREATE_OBJECTIF_N_MOINS_1_SUCCESS,
    CREATE_OBJECTIF_REQUEST,
    CREATE_OBJECTIF_REVISION_FAIL,
    CREATE_OBJECTIF_REVISION_REQUEST,
    CREATE_OBJECTIF_REVISION_SUCCESS,
    CREATE_OBJECTIF_SUCCESS,
    CREATE_PLAN_DEVELOPPEMENT_ITEM_FAIL,
    CREATE_PLAN_DEVELOPPEMENT_ITEM_REQUEST,
    CREATE_PLAN_DEVELOPPEMENT_ITEM_SUCCESS,
    FETCH_COMPETENCES_GENERIQUES_STEP_FAIL,
    FETCH_COMPETENCES_GENERIQUES_STEP_REQUEST,
    FETCH_COMPETENCES_GENERIQUES_STEP_SUCCESS,
    FETCH_COMPETENCES_SPECIFIQUES_STEP_FAIL,
    FETCH_COMPETENCES_SPECIFIQUES_STEP_REQUEST,
    FETCH_COMPETENCES_SPECIFIQUES_STEP_SUCCESS,
    FETCH_CONSOLIDATION_CAMPAGNE_FAIL,
    FETCH_CONSOLIDATION_CAMPAGNE_REQUEST,
    FETCH_CONSOLIDATION_CAMPAGNE_SUCCESS,
    FETCH_ENTRETIEN_ANNUEL_FAIL,
    FETCH_ENTRETIEN_ANNUEL_REQUEST,
    FETCH_ENTRETIEN_ANNUEL_SUCCESS,
    FETCH_MANAGER_PERFORMANCE_DASHBOARD_FAIL,
    FETCH_MANAGER_PERFORMANCE_DASHBOARD_REQUEST,
    FETCH_MANAGER_PERFORMANCE_DASHBOARD_SUCCESS,
    FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_FAIL,
    FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_REQUEST,
    FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_SUCCESS,
    FETCH_OBJECTIF_MODIFICATION_REQUESTS_FAIL,
    FETCH_OBJECTIF_MODIFICATION_REQUESTS_REQUEST,
    FETCH_OBJECTIF_MODIFICATION_REQUESTS_SUCCESS,
    FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_FAIL,
    FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_REQUEST,
    FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_SUCCESS,
    FETCH_OBJECTIFS_N_FAIL,
    FETCH_OBJECTIFS_N_MOINS_1_STEP_FAIL,
    FETCH_OBJECTIFS_N_MOINS_1_STEP_REQUEST,
    FETCH_OBJECTIFS_N_MOINS_1_STEP_SUCCESS,
    FETCH_OBJECTIFS_N_REQUEST,
    FETCH_OBJECTIFS_N_SUCCESS,
    FETCH_PERFORMANCE_CAMPAIGN_CARDS_FAIL,
    FETCH_PERFORMANCE_CAMPAIGN_CARDS_REQUEST,
    FETCH_PERFORMANCE_CAMPAIGN_CARDS_SUCCESS,
    FETCH_PERFORMANCE_STEPPER_FAIL,
    FETCH_PERFORMANCE_STEPPER_REQUEST,
    FETCH_PERFORMANCE_STEPPER_SUCCESS,
    FETCH_PLAN_DEVELOPPEMENT_STEP_FAIL,
    FETCH_PLAN_DEVELOPPEMENT_STEP_REQUEST,
    FETCH_PLAN_DEVELOPPEMENT_STEP_SUCCESS,
    FETCH_PROGRESS_CONSOLIDATION_FAIL,
    FETCH_PROGRESS_CONSOLIDATION_REQUEST,
    FETCH_PROGRESS_CONSOLIDATION_SUCCESS,
    GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_FAIL,
    GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_REQUEST,
    GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_SUCCESS,
    PLANIFIER_ENTRETIEN_ANNUEL_FAIL,
    PLANIFIER_ENTRETIEN_ANNUEL_REQUEST,
    PLANIFIER_ENTRETIEN_ANNUEL_SUCCESS,
    RECALCULATE_CONSOLIDATION_CAMPAGNE_FAIL,
    RECALCULATE_CONSOLIDATION_CAMPAGNE_REQUEST,
    RECALCULATE_CONSOLIDATION_CAMPAGNE_SUCCESS,
    RECALCULATE_PROGRESS_CONSOLIDATION_FAIL,
    RECALCULATE_PROGRESS_CONSOLIDATION_REQUEST,
    RECALCULATE_PROGRESS_CONSOLIDATION_SUCCESS,
    REJECT_OBJECTIF_FAIL,
    REJECT_OBJECTIF_MODIFICATION_FAIL,
    REJECT_OBJECTIF_MODIFICATION_REQUEST,
    REJECT_OBJECTIF_MODIFICATION_SUCCESS,
    REJECT_OBJECTIF_REQUEST,
    REJECT_OBJECTIF_SUCCESS,
    REPLANIFIER_ENTRETIEN_ANNUEL_FAIL,
    REPLANIFIER_ENTRETIEN_ANNUEL_REQUEST,
    REPLANIFIER_ENTRETIEN_ANNUEL_SUCCESS,
    SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_FAIL,
    SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_REQUEST,
    SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_SUCCESS,
    SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_FAIL,
    SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_REQUEST,
    SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_SUCCESS,
    SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_FAIL,
    SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_REQUEST,
    SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_SUCCESS,
    SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_FAIL,
    SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_REQUEST,
    SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_SUCCESS,
    SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_FAIL,
    SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_REQUEST,
    SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_SUCCESS,
    SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_FAIL,
    SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_REQUEST,
    SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_SUCCESS,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_FAIL,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_REQUEST,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_SUCCESS,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_FAIL,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_REQUEST,
    SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_SUCCESS,
    START_PERFORMANCE_PROGRESS_FAIL,
    START_PERFORMANCE_PROGRESS_REQUEST,
    START_PERFORMANCE_PROGRESS_SUCCESS,
    SUBMIT_OBJECTIF_MODIFICATION_FAIL,
    SUBMIT_OBJECTIF_MODIFICATION_REQUEST,
    SUBMIT_OBJECTIF_MODIFICATION_SUCCESS,
    TERMINER_ENTRETIEN_ANNUEL_FAIL,
    TERMINER_ENTRETIEN_ANNUEL_REQUEST,
    TERMINER_ENTRETIEN_ANNUEL_SUCCESS,
} from "../actions/performanceActions";

const initialByProgress = {
    dataByProgressId: {},
    loadingByProgressId: {},
    errorByProgressId: {},
};

const initialState = {
    campaignCards: { data: [], loading: false, error: null },
    progress: {
        current: null,
        stepperByProgressId: {},
        loading: false,
        stepperLoadingByProgressId: {},
        error: null,
        stepperErrorByProgressId: {},
    },
    objectifsNMoins1: initialByProgress,
    objectifsN: initialByProgress,
    competencesGeneriques: { stepByProgressId: {}, loadingByProgressId: {}, errorByProgressId: {} },
    competencesSpecifiques: { stepByProgressId: {}, loadingByProgressId: {}, errorByProgressId: {} },
    planDeveloppement: { stepByProgressId: {}, loadingByProgressId: {}, errorByProgressId: {} },
    entretienAnnuel: { byProgressId: {}, loadingByProgressId: {}, errorByProgressId: {} },
    modificationsObjectifs: {
        byObjectifId: {},
        managerPending: [],
        loading: false,
        error: null,
    },
    manager: {
        collaborateursByCampagneId: {},
        loadingByCampagneId: {},
        errorByCampagneId: {},
    },
    consolidation: {
        byCampagneId: {},
        byProgressId: {},
        loadingByCampagneId: {},
        errorByCampagneId: {},
        loadingByProgressId: {},
        errorByProgressId: {},
    },
};

const getError = (action, fallback = "Erreur performance") => action.payload?.error || action.payload || fallback;
const key = (value) => String(value);
const groupRequestsByObjectifId = (requests) =>
    (Array.isArray(requests) ? requests : []).reduce((acc, request) => {
        if (request?.objectifId != null) {
            const objectifKey = key(request.objectifId);
            acc[objectifKey] = [...(acc[objectifKey] || []), request];
        }
        return acc;
    }, {});

const setByProgressLoading = (slice, progressId, loading) => ({
    ...slice,
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: loading },
    errorByProgressId: loading ? { ...slice.errorByProgressId, [key(progressId)]: null } : slice.errorByProgressId,
});

const setByProgressData = (slice, progressId, data) => ({
    ...slice,
    dataByProgressId: { ...slice.dataByProgressId, [key(progressId)]: data },
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: false },
    errorByProgressId: { ...slice.errorByProgressId, [key(progressId)]: null },
});

const setByProgressError = (slice, progressId, error) => ({
    ...slice,
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: false },
    errorByProgressId: { ...slice.errorByProgressId, [key(progressId)]: error },
});

const setStepLoading = setByProgressLoading;
const setStepError = setByProgressError;
const setStepData = (slice, progressId, data) => ({
    ...slice,
    stepByProgressId: { ...slice.stepByProgressId, [key(progressId)]: data },
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: false },
    errorByProgressId: { ...slice.errorByProgressId, [key(progressId)]: null },
});

const setStepDone = (slice, progressId) => ({
    ...slice,
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: false },
    errorByProgressId: { ...slice.errorByProgressId, [key(progressId)]: null },
});

const setEntretienData = (slice, progressId, data) => ({
    ...slice,
    byProgressId: { ...slice.byProgressId, [key(progressId)]: data || null },
    loadingByProgressId: { ...slice.loadingByProgressId, [key(progressId)]: false },
    errorByProgressId: { ...slice.errorByProgressId, [key(progressId)]: null },
});

export default function performanceReducer(state = initialState, action) {
    const progressId = action.payload?.progressId || action.payload?.data?.evaluationProgressId || action.payload?.response?.evaluationProgressId;
    const campagneId = action.payload?.campagneId;
    const objectifId = action.payload?.objectifId;

    switch (action.type) {
        case FETCH_PERFORMANCE_CAMPAIGN_CARDS_REQUEST:
            return { ...state, campaignCards: { ...state.campaignCards, loading: true, error: null } };
        case FETCH_PERFORMANCE_CAMPAIGN_CARDS_SUCCESS:
            return { ...state, campaignCards: { data: action.payload.data || [], loading: false, error: null } };
        case FETCH_PERFORMANCE_CAMPAIGN_CARDS_FAIL:
            return { ...state, campaignCards: { ...state.campaignCards, loading: false, error: getError(action) } };

        case START_PERFORMANCE_PROGRESS_REQUEST:
            return { ...state, progress: { ...state.progress, loading: true, error: null } };
        case START_PERFORMANCE_PROGRESS_SUCCESS:
            return { ...state, progress: { ...state.progress, current: action.payload.data, loading: false, error: null } };
        case START_PERFORMANCE_PROGRESS_FAIL:
            return { ...state, progress: { ...state.progress, loading: false, error: getError(action) } };

        case FETCH_PERFORMANCE_STEPPER_REQUEST:
            return {
                ...state,
                progress: {
                    ...state.progress,
                    stepperLoadingByProgressId: { ...state.progress.stepperLoadingByProgressId, [key(progressId)]: true },
                    stepperErrorByProgressId: { ...state.progress.stepperErrorByProgressId, [key(progressId)]: null },
                },
            };
        case FETCH_PERFORMANCE_STEPPER_SUCCESS:
            return {
                ...state,
                progress: {
                    ...state.progress,
                    stepperByProgressId: { ...state.progress.stepperByProgressId, [key(progressId)]: action.payload.data },
                    stepperLoadingByProgressId: { ...state.progress.stepperLoadingByProgressId, [key(progressId)]: false },
                    stepperErrorByProgressId: { ...state.progress.stepperErrorByProgressId, [key(progressId)]: null },
                },
            };
        case FETCH_PERFORMANCE_STEPPER_FAIL:
            return {
                ...state,
                progress: {
                    ...state.progress,
                    stepperLoadingByProgressId: { ...state.progress.stepperLoadingByProgressId, [key(progressId)]: false },
                    stepperErrorByProgressId: { ...state.progress.stepperErrorByProgressId, [key(progressId)]: getError(action) },
                },
            };

        case FETCH_OBJECTIFS_N_MOINS_1_STEP_REQUEST:
        case CREATE_OBJECTIF_N_MOINS_1_REQUEST:
            return { ...state, objectifsNMoins1: setByProgressLoading(state.objectifsNMoins1, progressId, true) };
        case FETCH_OBJECTIFS_N_MOINS_1_STEP_SUCCESS:
            return { ...state, objectifsNMoins1: setByProgressData(state.objectifsNMoins1, progressId, action.payload.data) };
        case CREATE_OBJECTIF_N_MOINS_1_SUCCESS:
            return { ...state, objectifsNMoins1: setByProgressLoading(state.objectifsNMoins1, progressId, false) };
        case FETCH_OBJECTIFS_N_MOINS_1_STEP_FAIL:
        case CREATE_OBJECTIF_N_MOINS_1_FAIL:
            return { ...state, objectifsNMoins1: setByProgressError(state.objectifsNMoins1, progressId, getError(action)) };

        case FETCH_OBJECTIFS_N_REQUEST:
            return { ...state, objectifsN: setByProgressLoading(state.objectifsN, progressId, true) };
        case FETCH_OBJECTIFS_N_SUCCESS:
            return { ...state, objectifsN: setByProgressData(state.objectifsN, progressId, action.payload.data || []) };
        case FETCH_OBJECTIFS_N_FAIL:
            return { ...state, objectifsN: setByProgressError(state.objectifsN, progressId, getError(action)) };

        case FETCH_COMPETENCES_GENERIQUES_STEP_REQUEST:
        case SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_REQUEST:
        case SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_REQUEST:
            return { ...state, competencesGeneriques: setStepLoading(state.competencesGeneriques, progressId, true) };
        case FETCH_COMPETENCES_GENERIQUES_STEP_SUCCESS:
            return { ...state, competencesGeneriques: setStepData(state.competencesGeneriques, progressId, action.payload.data) };
        case SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_SUCCESS:
        case SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_SUCCESS:
            return { ...state, competencesGeneriques: setStepDone(state.competencesGeneriques, progressId) };
        case FETCH_COMPETENCES_GENERIQUES_STEP_FAIL:
        case SAVE_ALL_COMPETENCES_GENERIQUES_AUTO_EVAL_FAIL:
        case SAVE_ALL_COMPETENCES_GENERIQUES_MANAGER_EVAL_FAIL:
            return { ...state, competencesGeneriques: setStepError(state.competencesGeneriques, progressId, getError(action)) };

        case FETCH_COMPETENCES_SPECIFIQUES_STEP_REQUEST:
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_REQUEST:
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_REQUEST:
            return { ...state, competencesSpecifiques: setStepLoading(state.competencesSpecifiques, progressId, true) };
        case FETCH_COMPETENCES_SPECIFIQUES_STEP_SUCCESS:
            return { ...state, competencesSpecifiques: setStepData(state.competencesSpecifiques, progressId, action.payload.data) };
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_SUCCESS:
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_SUCCESS:
            return { ...state, competencesSpecifiques: setStepDone(state.competencesSpecifiques, progressId) };
        case FETCH_COMPETENCES_SPECIFIQUES_STEP_FAIL:
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_AUTO_EVAL_FAIL:
        case SAVE_ALL_COMPETENCES_SPECIFIQUES_MANAGER_EVAL_FAIL:
            return { ...state, competencesSpecifiques: setStepError(state.competencesSpecifiques, progressId, getError(action)) };

        case FETCH_PLAN_DEVELOPPEMENT_STEP_REQUEST:
        case GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_REQUEST:
        case CREATE_PLAN_DEVELOPPEMENT_ITEM_REQUEST:
        case CREATE_DEMANDE_FORMATION_FROM_PLAN_REQUEST:
        case COMPLETE_PLAN_DEVELOPPEMENT_STEP_REQUEST:
            return progressId ? { ...state, planDeveloppement: setStepLoading(state.planDeveloppement, progressId, true) } : state;
        case FETCH_PLAN_DEVELOPPEMENT_STEP_SUCCESS:
        case GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_SUCCESS:
        case COMPLETE_PLAN_DEVELOPPEMENT_STEP_SUCCESS:
            return { ...state, planDeveloppement: setStepData(state.planDeveloppement, progressId, action.payload.data) };
        case FETCH_PLAN_DEVELOPPEMENT_STEP_FAIL:
        case GENERATE_PLAN_DEVELOPPEMENT_RECOMMENDATIONS_FAIL:
        case CREATE_PLAN_DEVELOPPEMENT_ITEM_FAIL:
        case CREATE_DEMANDE_FORMATION_FROM_PLAN_FAIL:
        case COMPLETE_PLAN_DEVELOPPEMENT_STEP_FAIL:
            return progressId ? { ...state, planDeveloppement: setStepError(state.planDeveloppement, progressId, getError(action)) } : state;

        case FETCH_ENTRETIEN_ANNUEL_REQUEST:
        case PLANIFIER_ENTRETIEN_ANNUEL_REQUEST:
        case REPLANIFIER_ENTRETIEN_ANNUEL_REQUEST:
        case CONFIRMER_ENTRETIEN_ANNUEL_REQUEST:
        case ANNULER_ENTRETIEN_ANNUEL_REQUEST:
        case TERMINER_ENTRETIEN_ANNUEL_REQUEST:
            return progressId ? { ...state, entretienAnnuel: setByProgressLoading(state.entretienAnnuel, progressId, true) } : state;
        case FETCH_ENTRETIEN_ANNUEL_SUCCESS:
        case PLANIFIER_ENTRETIEN_ANNUEL_SUCCESS:
        case REPLANIFIER_ENTRETIEN_ANNUEL_SUCCESS:
        case CONFIRMER_ENTRETIEN_ANNUEL_SUCCESS:
        case ANNULER_ENTRETIEN_ANNUEL_SUCCESS:
        case TERMINER_ENTRETIEN_ANNUEL_SUCCESS:
            return { ...state, entretienAnnuel: setEntretienData(state.entretienAnnuel, progressId, action.payload.data) };
        case FETCH_ENTRETIEN_ANNUEL_FAIL:
        case PLANIFIER_ENTRETIEN_ANNUEL_FAIL:
        case REPLANIFIER_ENTRETIEN_ANNUEL_FAIL:
        case CONFIRMER_ENTRETIEN_ANNUEL_FAIL:
        case ANNULER_ENTRETIEN_ANNUEL_FAIL:
        case TERMINER_ENTRETIEN_ANNUEL_FAIL:
            return progressId ? { ...state, entretienAnnuel: setByProgressError(state.entretienAnnuel, progressId, getError(action)) } : state;

        case FETCH_OBJECTIF_MODIFICATION_REQUESTS_REQUEST:
        case FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_REQUEST:
        case FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_REQUEST:
        case SUBMIT_OBJECTIF_MODIFICATION_REQUEST:
        case APPROVE_OBJECTIF_MODIFICATION_REQUEST:
        case REJECT_OBJECTIF_MODIFICATION_REQUEST:
        case CANCEL_OBJECTIF_MODIFICATION_REQUEST:
            return { ...state, modificationsObjectifs: { ...state.modificationsObjectifs, loading: true, error: null } };
        case FETCH_OBJECTIF_MODIFICATION_REQUESTS_SUCCESS:
            return {
                ...state,
                modificationsObjectifs: {
                    ...state.modificationsObjectifs,
                    byObjectifId: { ...state.modificationsObjectifs.byObjectifId, [key(objectifId)]: action.payload.data || [] },
                    loading: false,
                    error: null,
                },
            };
        case FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_SUCCESS:
            return {
                ...state,
                modificationsObjectifs: {
                    ...state.modificationsObjectifs,
                    byObjectifId: {
                        ...state.modificationsObjectifs.byObjectifId,
                        ...groupRequestsByObjectifId(action.payload.data),
                    },
                    loading: false,
                    error: null,
                },
            };
        case FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_SUCCESS:
            return { ...state, modificationsObjectifs: { ...state.modificationsObjectifs, managerPending: action.payload.data || [], loading: false, error: null } };
        case SUBMIT_OBJECTIF_MODIFICATION_SUCCESS:
        case APPROVE_OBJECTIF_MODIFICATION_SUCCESS:
        case REJECT_OBJECTIF_MODIFICATION_SUCCESS:
        case CANCEL_OBJECTIF_MODIFICATION_SUCCESS:
            return { ...state, modificationsObjectifs: { ...state.modificationsObjectifs, loading: false, error: null } };
        case FETCH_OBJECTIF_MODIFICATION_REQUESTS_FAIL:
        case FETCH_PROGRESS_OBJECTIF_MODIFICATION_REQUESTS_FAIL:
        case FETCH_MANAGER_PENDING_OBJECTIF_MODIFICATIONS_FAIL:
        case SUBMIT_OBJECTIF_MODIFICATION_FAIL:
        case APPROVE_OBJECTIF_MODIFICATION_FAIL:
        case REJECT_OBJECTIF_MODIFICATION_FAIL:
        case CANCEL_OBJECTIF_MODIFICATION_FAIL:
            return { ...state, modificationsObjectifs: { ...state.modificationsObjectifs, loading: false, error: getError(action) } };

        case CREATE_OBJECTIF_REQUEST:
        case APPROVE_OBJECTIF_REQUEST:
        case REJECT_OBJECTIF_REQUEST:
        case CREATE_OBJECTIF_REVISION_REQUEST:
        case CREATE_OBJECTIF_AUTO_EVALUATION_REQUEST:
        case CREATE_OBJECTIF_MANAGER_EVALUATION_REQUEST:
        case SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_REQUEST:
        case SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_REQUEST:
        case SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_REQUEST:
        case SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_REQUEST:
            return { ...state };
        case CREATE_OBJECTIF_SUCCESS:
        case APPROVE_OBJECTIF_SUCCESS:
        case REJECT_OBJECTIF_SUCCESS:
        case CREATE_OBJECTIF_REVISION_SUCCESS:
        case CREATE_OBJECTIF_AUTO_EVALUATION_SUCCESS:
        case CREATE_OBJECTIF_MANAGER_EVALUATION_SUCCESS:
        case CREATE_PLAN_DEVELOPPEMENT_ITEM_SUCCESS:
        case CREATE_DEMANDE_FORMATION_FROM_PLAN_SUCCESS:
        case SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_SUCCESS:
        case SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_SUCCESS:
        case SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_SUCCESS:
        case SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_SUCCESS:
            return { ...state };
        case CREATE_OBJECTIF_FAIL:
        case APPROVE_OBJECTIF_FAIL:
        case REJECT_OBJECTIF_FAIL:
        case CREATE_OBJECTIF_REVISION_FAIL:
        case CREATE_OBJECTIF_AUTO_EVALUATION_FAIL:
        case CREATE_OBJECTIF_MANAGER_EVALUATION_FAIL:
        case SAVE_COMPETENCE_GENERIQUE_AUTO_EVAL_FAIL:
        case SAVE_COMPETENCE_GENERIQUE_MANAGER_EVAL_FAIL:
        case SAVE_COMPETENCE_SPECIFIQUE_AUTO_EVAL_FAIL:
        case SAVE_COMPETENCE_SPECIFIQUE_MANAGER_EVAL_FAIL:
            return { ...state, progress: { ...state.progress, error: getError(action) } };

        case FETCH_MANAGER_PERFORMANCE_DASHBOARD_REQUEST:
            return {
                ...state,
                manager: {
                    ...state.manager,
                    loadingByCampagneId: { ...state.manager.loadingByCampagneId, [key(campagneId)]: true },
                    errorByCampagneId: { ...state.manager.errorByCampagneId, [key(campagneId)]: null },
                },
            };
        case FETCH_MANAGER_PERFORMANCE_DASHBOARD_SUCCESS:
            return {
                ...state,
                manager: {
                    ...state.manager,
                    collaborateursByCampagneId: { ...state.manager.collaborateursByCampagneId, [key(campagneId)]: action.payload.data || [] },
                    loadingByCampagneId: { ...state.manager.loadingByCampagneId, [key(campagneId)]: false },
                    errorByCampagneId: { ...state.manager.errorByCampagneId, [key(campagneId)]: null },
                },
            };
        case FETCH_MANAGER_PERFORMANCE_DASHBOARD_FAIL:
            return {
                ...state,
                manager: {
                    ...state.manager,
                    loadingByCampagneId: { ...state.manager.loadingByCampagneId, [key(campagneId)]: false },
                    errorByCampagneId: { ...state.manager.errorByCampagneId, [key(campagneId)]: getError(action) },
                },
            };

        case FETCH_CONSOLIDATION_CAMPAGNE_REQUEST:
        case RECALCULATE_CONSOLIDATION_CAMPAGNE_REQUEST:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    loadingByCampagneId: { ...state.consolidation.loadingByCampagneId, [key(campagneId)]: true },
                    errorByCampagneId: { ...state.consolidation.errorByCampagneId, [key(campagneId)]: null },
                },
            };
        case FETCH_CONSOLIDATION_CAMPAGNE_SUCCESS:
        case RECALCULATE_CONSOLIDATION_CAMPAGNE_SUCCESS:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    byCampagneId: { ...state.consolidation.byCampagneId, [key(campagneId)]: action.payload.data },
                    loadingByCampagneId: { ...state.consolidation.loadingByCampagneId, [key(campagneId)]: false },
                    errorByCampagneId: { ...state.consolidation.errorByCampagneId, [key(campagneId)]: null },
                },
            };
        case FETCH_CONSOLIDATION_CAMPAGNE_FAIL:
        case RECALCULATE_CONSOLIDATION_CAMPAGNE_FAIL:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    loadingByCampagneId: { ...state.consolidation.loadingByCampagneId, [key(campagneId)]: false },
                    errorByCampagneId: { ...state.consolidation.errorByCampagneId, [key(campagneId)]: getError(action) },
                },
            };

        case FETCH_PROGRESS_CONSOLIDATION_REQUEST:
        case RECALCULATE_PROGRESS_CONSOLIDATION_REQUEST:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    loadingByProgressId: { ...state.consolidation.loadingByProgressId, [key(progressId)]: true },
                    errorByProgressId: { ...state.consolidation.errorByProgressId, [key(progressId)]: null },
                },
            };
        case FETCH_PROGRESS_CONSOLIDATION_SUCCESS:
        case RECALCULATE_PROGRESS_CONSOLIDATION_SUCCESS:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    byProgressId: { ...state.consolidation.byProgressId, [key(progressId)]: action.payload.data },
                    loadingByProgressId: { ...state.consolidation.loadingByProgressId, [key(progressId)]: false },
                    errorByProgressId: { ...state.consolidation.errorByProgressId, [key(progressId)]: null },
                },
            };
        case FETCH_PROGRESS_CONSOLIDATION_FAIL:
        case RECALCULATE_PROGRESS_CONSOLIDATION_FAIL:
            return {
                ...state,
                consolidation: {
                    ...state.consolidation,
                    loadingByProgressId: { ...state.consolidation.loadingByProgressId, [key(progressId)]: false },
                    errorByProgressId: { ...state.consolidation.errorByProgressId, [key(progressId)]: getError(action) },
                },
            };

        default:
            return state;
    }
}
